import { BASE_URL } from "@src/utils";
import { MyWeddingContractInfo } from "@src/types/weddingHall";
import axios from "../axios";
import { ServerResponse, ServerResponseResult } from "../axios";

export const getContractInfo = (contractUuid: string) => {
  const url = `${BASE_URL}/v3/book/20240729/halls/weddings/contracts/${contractUuid}`;

  return axios.get<{ item: MyWeddingContractInfo }>(url);
};

// 푸시설정 가져오기
export const getPushSetting = () => {
  const url = `${BASE_URL}/v4/20241113/pushsetting`;
  return axios.get<
    ServerResponse<{
      allAgree: 0 | 1;
      community: 0 | 1;
      content: 0 | 1;
      event: 0 | 1;
      best: 0 | 1;
      communityNight: 0 | 1;
      chat: 0 | 1;
    }>
  >(url);
};

// 푸시설정 변경
export const putPushSetting = (params: {
  allAgree?: 0 | 1;
  community?: 0 | 1;
  content?: 0 | 1;
  event?: 0 | 1;
  best?: 0 | 1;
  communityNight?: 0 | 1;
  chat?: 0 | 1;
}) => {
  const url = `${BASE_URL}/v4/20241113/pushsetting`;
  return axios.put<ServerResponseResult>(url, params);
};

// 마케팅 수신동의 상태 변경
export const putMarketingAgree = (params: { state: 1 | 0; inPath: "MYPAGE" }) => {
  const url = `${BASE_URL}/v4/20241113/customer/terms/MARKETING`;
  return axios.put<ServerResponseResult>(url, params);
};

export const getUnreadChatInfo = () => {
  return axios.get<any>(`${BASE_URL}/v3/mypage/total-push-chat`);
};
